import React from 'react';
import ReactModal from 'react-modal';
import NovaPergunta from './CadastrarPergunta';
import EditarPergunta from './EditarPergunta';
import Pesquisa from '../PesquisaUsuarios';

const PerguntaModals = ({ modalIsOpen, closeModal, modalTipo, perguntaAtual, atualizarPerguntas, visualizarModalIsOpen, closeVisualizarModal, isSubPergunta }) => {
  return (
    <>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        ariaHideApp={false}
        style={{
          content: {
            width: '50%',
            height: '78%',
            margin: 'auto',
          },
        }}
      >
        {modalTipo === 'novo' ? (
          <NovaPergunta 
            closeModal={closeModal} 
            atualizarPerguntas={atualizarPerguntas} 
            perguntaPai={perguntaAtual} 
            isSubPergunta={isSubPergunta}
          />
        ) : (
          <EditarPergunta 
            pergunta={perguntaAtual} 
            closeModal={closeModal} 
            atualizarPerguntas={atualizarPerguntas} 
          />
        )}
      </ReactModal>

      <ReactModal
        isOpen={visualizarModalIsOpen}
        onRequestClose={closeVisualizarModal}
        ariaHideApp={false}
        style={{
          content: {
            width: '50%',
            height: '70%',
            margin: 'auto',
          },
        }}
      >
        <Pesquisa />
      </ReactModal>
    </>
  );
};

export default PerguntaModals;
